if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.initializeSantaOptions();
        this.addEventListener('change', (event) => {
          if (this.isSanta && !this.prepareSantaChange(event)) return;
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }



      disconnectedCallback() {
        this.santaObserver?.disconnect();
      }
      initializeSantaOptions() {
        this.isSanta = this.dataset.url === '/products/santa-hat-plain-or-personalized';
        if (!this.isSanta) return;
        this.santaRoot = this.closest('product-info');
        this.santaStyle = this.querySelector('select[name="options[Style]"]');
        this.santaFont = this.querySelector('select[name="options[Font]"]');
        this.santaThread = this.querySelector('select[name="options[Thread Color]"]');
        if (!this.santaRoot || !this.santaStyle || !this.santaFont || !this.santaThread) return;
        this.setupSantaStyleButtons();
        this.santaObserver = new MutationObserver(() => this.syncSantaFields());
        this.santaObserver.observe(this.santaRoot, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','required']});
        this.syncSantaFields();
      }
      setupSantaStyleButtons() {
        const field = this.santaStyle.closest('.product-form__input');
        if (!field || field.querySelector('.tah-santa-style-choices')) return;
        field.classList.add('tah-santa-style-input');
        const choices = document.createElement('div');
        choices.className = 'tah-santa-style-choices';
        choices.setAttribute('role', 'group');
        choices.setAttribute('aria-label', 'Style');
        for (const value of ['Plain', 'Personalized']) {
          const button = document.createElement('a');
          button.href = this.dataset.url + '?variant=' + (value === 'Plain' ? '67699818168598' : '67699818201366');
          button.textContent = value;
          button.dataset.santaStyle = value;
          choices.appendChild(button);
        }
        field.appendChild(choices);
        if (!document.getElementById('tah-santa-style-mobile-css')) {
          const css = document.createElement('style');
          css.id = 'tah-santa-style-mobile-css';
          css.textContent = '@media(max-width:749px){.tah-santa-style-input .select{display:none!important}.tah-santa-style-choices{display:grid!important;grid-template-columns:1fr 1fr;gap:10px;margin-top:8px}.tah-santa-style-choices a{min-height:48px;padding:10px;border:1px solid currentColor;display:flex;align-items:center;justify-content:center;text-decoration:none;border-radius:24px;background:transparent;color:inherit;font:inherit;cursor:pointer}.tah-santa-style-choices a[aria-pressed="true"]{background:#fff;color:#111;border-color:#fff;font-weight:700}}@media(min-width:750px){.tah-santa-style-choices{display:none!important}}';
          document.head.appendChild(css);
        }
        this.syncSantaStyleButtons();
      }
      syncSantaStyleButtons() {
        for (const button of this.querySelectorAll('.tah-santa-style-choices a')) {
          button.setAttribute('aria-pressed', String(button.dataset.santaStyle === this.santaStyle.value));
        }
      }
      selectSantaValue(select, value) {
        select.value = value;
        for (const option of select.options) {
          if (option === select.selectedOptions[0]) option.setAttribute('selected','selected');
          else option.removeAttribute('selected');
        }
      }
      prepareSantaChange(event) {
        if (event.target === this.santaStyle) {
          this.selectSantaValue(this.santaStyle, this.santaStyle.value);
          const plain = this.santaStyle.value === 'Plain';
          this.selectSantaValue(this.santaFont, plain ? 'No embroidery' : 'Script (Cursive)');
          this.selectSantaValue(this.santaThread, plain ? 'No embroidery' : 'Gold');
        }
        this.syncSantaFields();
        return true;
      }
      syncSantaFields() {
        if (!this.isConnected || !this.santaRoot) return;
        const personalized = this.santaStyle.value === 'Personalized';
        if (this.santaRoot.dataset.santaGroupPersonalized !== String(personalized)) this.santaRoot.dataset.santaGroupPersonalized = String(personalized);
        this.syncSantaStyleButtons();
        for (const select of [this.santaFont,this.santaThread]) {
          select.closest('.product-form__input').style.display = 'none';
          if (select.required) select.required = false;
        }
        for (const input of this.santaRoot.querySelectorAll('input[name="properties[Embroidery text]"]')) {
          (input.closest('.tpo_option-container') || input.parentElement).style.display = 'none';
          if (!input.disabled) input.disabled = true;
          if (input.required) input.required = false;
          input.setAttribute('data-required','0');
          if (input.value) input.value = '';
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
